import { useMutation } from "react-query";
import { PaginateResult } from "core/resources/types/shared";
import { VotacaoParticipanteItem } from "../typings";
import axios from "infra/http";

function useParticipantesAssembleiaListaCompleta(
  id: string,
) {
  return useMutation(
    `/v1/votacao/${id}/participantes/lista-completa`,
    async () => {
      const { data } = await axios.get<PaginateResult<VotacaoParticipanteItem>>(
        `/v1/votacao/${id}/participantes`,
        {
          params: {
            page: 1,
            limit: 99999,
          },
        }
      );

      return data;
    },
  );
}

export default useParticipantesAssembleiaListaCompleta;
